import { useIsMutating, useMutation } from '@tanstack/react-query'

import { bulkImportMultiSiteRestrictions } from '@/features/site/endpoints/restrictions'
import type { MultiSiteBulkImportRestrictionsRequest } from '@/features/site/types/restriction'

const MULTI_SITE_BULK_IMPORT_RESTRICTIONS_API_ID = 'MULTI_SITE_BULK_IMPORT_RESTRICTIONS'

export function useMultiSiteBulkImportRestrictionsMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (data: MultiSiteBulkImportRestrictionsRequest) => bulkImportMultiSiteRestrictions(data),
    mutationKey: [MULTI_SITE_BULK_IMPORT_RESTRICTIONS_API_ID],
  })

  return {
    bulkImportRestrictions: mutateAsync,
    ...mutationResult,
  }
}

export const useIsMultiSiteBulkImportingRestrictions = (): boolean =>
  useIsMutating({ mutationKey: [MULTI_SITE_BULK_IMPORT_RESTRICTIONS_API_ID] }) > 0
